import { endeavorMetadataUnpack } from '../helpers/endeavor-metadata-unpack';
import { fetchToken, getToken } from './auth-service';
import {
    ENDEAVOR_AUTH,
    GRANTED,
    REACT_APP_ENDEAVOR_BASE_URL,
    REACT_APP_ENDEAVOR_REALM,
    REACT_APP_ENDEAVOR_X_API_KEY
} from '../constants/api-constants';
import { deleteFromSessionStorage, setSessionStorageItem } from '../../../utils';
import api from '../endeavor-api';

export const getVideoOnDemandByID = async ({ videoId, authToken }) => {
    try {
        const response = await api.get(`${REACT_APP_ENDEAVOR_BASE_URL}/api/v4/vod/${videoId}`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${authToken}`,
                'x-api-key': REACT_APP_ENDEAVOR_X_API_KEY,
                Realm: REACT_APP_ENDEAVOR_REALM,
            },
        });

        const responseData = response.data;
        return {
            metadata: responseData,
            error: { isEmpty: true },
        };
    } catch (error) {
        return {
            error: {
                isEmpty: false,
                value: error,
                statusCode: error.response.status
            },
            metadata: { isEmpty: true },
        };
    }
};


const getVideoExtendedAsync = async ({ videoId, authToken }) => {
    try {
        const response = await api.get(`${REACT_APP_ENDEAVOR_BASE_URL}/api/v3/stream/vod/${videoId}`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${authToken}`,
                'x-api-key': REACT_APP_ENDEAVOR_X_API_KEY,
                Realm: REACT_APP_ENDEAVOR_REALM,
            },
        });

        const responseData = response.data;

        return {
            playerUrlCallback: responseData.playerUrlCallback,
            error: { isEmpty: true },
        };
    } catch (error) {
        return {
            error: {
                isEmpty: false,
                value: error,
            },
            playerUrlCallback: { isEmpty: true },
        };
    }
};

const getVideoUrlAsync = async ({ videoId, authToken }) => {
    try {
        const videoExtended = await getVideoExtendedAsync({ videoId, authToken });
        const response = await api.get(videoExtended.playerUrlCallback, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${authToken}`,
            },

        });

        const responseData = response.data;
        return {
            dashUrl: responseData.dash[0].url,
            hlsUrl: responseData.hls[0].url,
            error: { isEmpty: true },
        };
    } catch (error) {
        return {
            error: {
                isEmpty: false,
                value: error,
            },
            dashUrl: { isEmpty: true },
        };
    }
};


export const getVideoMetadataAsync = async ({ videoId }) => {
    try {
        let videoUrl;
        let videoByID;

        let authToken = await getToken();
        videoByID = await getVideoOnDemandByID({
            videoId,
            authToken,
        });

        if (!videoByID.error.isEmpty && videoByID.error.value.response.status === 401) {
            authToken = await fetchToken();
            videoByID = await getVideoOnDemandByID({ videoId, authToken });
            deleteFromSessionStorage(ENDEAVOR_AUTH);
            setSessionStorageItem(ENDEAVOR_AUTH, authToken);
        }

        if (!videoByID.error.isEmpty) {
            return {
                metadata: { isEmpty: true },
                error: videoByID.error,
            };
        }

        if (videoByID.metadata.accessLevel === GRANTED) {
            videoUrl = await getVideoUrlAsync({
                videoId,
                authToken,
            });
        }

        return {
            metadata: endeavorMetadataUnpack(
                { endeavorMetadata: videoByID, endeavorVideo: videoUrl },
            ),
            error: { isEmpty: true },
        };
    } catch (error) {
        return {
            error: {
                isEmpty: false,
                value: error,
            },
            thumbnailSrc: { isEmpty: true },
        };
    }
};
